import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import buttonIncluirComponent from "@/components/child/form/button/buttonIncluir.vue";
import checkboxComponent from "@/components/child/form/checkbox.vue";
import dataTooltipComponent from "@/components/child/form/datatooltip.vue";
import decimalComSinalCustomComponent from "@/components/child/form/decimalComSinalCustom.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import moedaComponent from "@/components/child/form/moeda.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import BeneficioFaixaModel from "@/models/beneficio/beneficioFaixaModel";
import BeneficioModel from "@/models/beneficio/beneficioModel";
import TipoBeneficio from "@/models/enum/tipoBeneficio";
import beneficioService from "@/services/beneficioService";

import EditComponentBase from "../editComponentBase";

import "../crud.scss";

@Component({
    components: {
        checkboxComponent,
        dataTooltipComponent,
        gridComponent,
        decimalComSinalCustomComponent,
        moedaComponent,
        fieldsetComponent,
        buttonIncluirComponent,
        actionBarComponent,
    },
})
export default class BeneficiosEditComponent extends EditComponentBase<BeneficioModel> {
    gridFaixaColums: Array<GridColumn> = [
        new GridColumn("inicioFaixa", "Faixa Inicio", GridColumnType.Money),
        new GridColumn("fimFaixa", "Faixa Fim", GridColumnType.Money),
        new GridColumn("valor", "Valor", GridColumnType.Integer),
    ];

    faixaDesconto = new BeneficioFaixaModel(TipoBeneficio.Desconto);
    faixaComissao = new BeneficioFaixaModel();

    private async beforeMount() {
        await this.setPropsCached(beneficioService, "beneficios", new BeneficioModel(), false, true);
    }

    // Benefício sem franquia é global do sistema: a base marca somenteConsulta e aqui só avisamos o
    // motivo, senão o usuário encontra a tela travada sem explicação.
    public async onAfterLoadModel() {
        if (this.somenteConsulta && this.model.franquiaId == null) {
            this.$notifyInfo(
                this.$t("__.ts.beneficioGlobalNaoAlteravel"),
                this.$t("__.ts.beneficioSomenteLeitura"),
            );
        }
    }

    private async onAddFaixa(tipoFaixa: TipoBeneficio) {
        if (
            this.faixaComissao.inicioFaixa < this.faixaComissao.fimFaixa ||
            this.faixaDesconto.inicioFaixa < this.faixaDesconto.fimFaixa
        ) {
            const model = new BeneficioFaixaModel();
            if (tipoFaixa == TipoBeneficio.Comissao) {
                const results = Promise.all([]);
                const areValid = (await results).every(isValid => isValid);
                if (areValid) {
                    model.updateFrom(this.faixaComissao);
                    this.faixaComissao = new BeneficioFaixaModel();
                    this.model.beneficioFaixas.push(model);
                }
            } else {
                const results = Promise.all([]);
                const areValid = (await results).every(isValid => isValid);
                if (areValid) {
                    model.updateFrom(this.faixaDesconto);
                    this.faixaDesconto = new BeneficioFaixaModel(TipoBeneficio.Desconto);
                    this.model.beneficioFaixas.push(model);
                }
            }
        } else {
            this.$showWarning("Atenção", "Não e permitido faixa final menor ou igual a faixa inicial.");
        }
    }

    private onRemoveFaixa(item: BeneficioFaixaModel) {
        const index = this.model.beneficioFaixas.indexOf(item);

        this.model.beneficioFaixas.splice(index, 1);
    }
}
